import { RootPage } from '../page';
import $api from '../../api';
import { } from '../../models/Gen/BaseModels';
import AlertsView from './views/alerts';

class DebuggerOverviewView extends RootPage {
    constructor() {
        super();

        this.deferUpdates = true;

        AlertsView(this);

        this.setActiveTab('alerts');

        this.debuggerActive = ko.observable(window.serverSide.debuggerActive);
    }

    onInit() {
        
    }

    setDebuggerActive() {
        const val = this.debuggerActive();

        $api.projects.setDebuggerState(
            { projectCode: auth.project.UniqueCode, state: val },
            {},
            () => {
                this.showToast('Debugger was ' + (val ? 'enabled' : 'disabled') + ' for your user account.');
            }
        )
    }
}

export default DebuggerOverviewView;